import { DataType } from 'vince-core/types/common';

export enum FormatType {
    DATE = 'date',
    TIME = 'time',
    DATE_TIME = 'date-time',
    ISO_TIME = 'iso-time',
    ISO_DATE_TIME = 'iso-date-time',
    DURATION = 'duration',
    URI = 'uri',
    URI_REFERENCE = 'uri-reference',
    URI_TEMPLATE = 'uri-template',
    URL = 'url',
    EMAIL = 'email',
    HOSTNAME = 'hostname',
    IPV4 = 'ipv4',
    IPV6 = 'ipv6',
    REGEX = 'regex',
    UUID = 'uuid',
    JSON_POINTER = 'json-pointer',
    RELATIVE_JSON_POINTER = 'relative-json-pointer',
    BYTE = 'byte',
    INT32 = 'int32',
    INT64 = 'int64',
    FLOAT = 'float',
    DOUBLE = 'double',
    PASSWORD = 'password',
    BINARY = 'binary',
    M3_DATE = 'm3-date'
}

export enum JsonSchemaType {
    STRING = 'string',
    NUMBER = 'number',
    DATE = 'date',
    INTEGER = 'integer',
    BOOLEAN = 'boolean',
    ARRAY = 'array',
    OBJECT = 'object',
    NULL = 'null'
}

export const JsonTypesToDataTypesMapping = {
    [JsonSchemaType.STRING]: DataType.STRING,
    [JsonSchemaType.NUMBER]: DataType.NUMERIC,
    [JsonSchemaType.INTEGER]: DataType.NUMERIC,
    [JsonSchemaType.DATE]: DataType.DATE
} as Record<JsonSchemaType, DataType>;
